import { EUserType } from "@dreamcam/messenger-sdk";
import { create } from "zustand";

export type TUserMsgData = {
	chat_client_id: string | null;
	user_type: EUserType;
};

export type TMessengerUnsupportedByUser = {
	nickname: string;
	categoryColor: string;
	isDisabled: boolean;
};

export type TMessengerStore = {
	userMsgData: TUserMsgData;
	setUserMsgData: ({ chat_client_id, user_type }: TUserMsgData) => void;
	countUnreadMessages: number;
	setCountUnreadMessages: (count: number) => void;
	activeChat: string | null;
	setActiveChat: (chatId: string | null) => void;
	messengerUnsupportedByUser: TMessengerUnsupportedByUser;
	setMessengerUnsupportedByUser: (value: TMessengerUnsupportedByUser) => void;
	isOpenMessenger: boolean;
	setIsOpenMessenger: (value: boolean) => void;
	isMessagesBoxFolded: boolean;
	setIsMessagesBoxFolded: (value: boolean) => void;
	isAuthMessenger: boolean;
	setIsAuthMessenger: (value: boolean) => void;
	resetState: () => void;
};

export const useMessengerStore = create<TMessengerStore>()((set, _, store) => ({
	userMsgData: {
		chat_client_id: "",
		user_type: EUserType.MODEL,
	},
	setUserMsgData: (data) => set({ userMsgData: data }),
	countUnreadMessages: 0,
	setCountUnreadMessages: (count) => set({ countUnreadMessages: count }),
	activeChat: null,
	setActiveChat: (chat) => set({ activeChat: chat }),
	messengerUnsupportedByUser: { nickname: "", categoryColor: "", isDisabled: false },
	setMessengerUnsupportedByUser: (value) => set({ messengerUnsupportedByUser: value }),
	isOpenMessenger: false,
	setIsOpenMessenger: (isOpen) => set({ isOpenMessenger: isOpen }),
	isMessagesBoxFolded: false,
	setIsMessagesBoxFolded: (isFolded) => set({ isMessagesBoxFolded: isFolded }),
	isAuthMessenger: false,
	setIsAuthMessenger: (isAuth) => set({ isAuthMessenger: isAuth }),
	resetState: () => {
		set(store.getInitialState(), true);
	},
}));
